import { useEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQuery } from 'types/graphql';
import '../queries/enterprise-loyalty-settings.gql';

type UseSearchEnterpriseParams = {
  enterpriseId?: string;
};

type UseSearchEnterpriseReturn = {
  enterprise: GqlEnterpriseLoyaltySettingsQuery['enterpriseLoyaltySettings'];
  loading: boolean;
  error: any;
};

export function useSearchEnterprise({ enterpriseId }: UseSearchEnterpriseParams): UseSearchEnterpriseReturn {
  const skip = !enterpriseId;

  const { data, loading, error } = useEnterpriseLoyaltySettingsQuery({
    variables: { enterpriseId: enterpriseId ?? '' },
    skip,
  });

  return {
    enterprise: data?.enterpriseLoyaltySettings ?? null,
    loading,
    error,
  };
}
